import { DraggerComponent } from './DraggerComponent.main';

export { DraggerComponent };
